module.exports = __webpack_public_path__ + "img/pnu_gallery4.6d4437fb.jpg";